export default __webpack_public_path__ + "static/media/3S.ed80cdda.svg";